/**
 * Zentraler Logger-Wrapper für die Anwendung.
 * In Produktion werden nur Warnungen und Fehler ausgegeben.
 * In der Entwicklung werden alle Logs ausgegeben.
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

class Logger {
  private isProduction = import.meta.env.PROD;

  private formatMessage(level: LogLevel, message: string, ..._args: unknown[]): string {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] [${level.toUpperCase()}] ${message}`;
  }

  debug(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.debug(this.formatMessage('debug', message), ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.info(this.formatMessage('info', message), ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    console.warn(this.formatMessage('warn', message), ...args);
  }

  error(message: string, error?: unknown, ...args: unknown[]): void {
    console.error(this.formatMessage('error', message), error, ...args);
  }

  /**
   * Spezieller Logger für Firebase-Events oder andere Analytics,
   * falls später benötigt.
   */
  logEvent(eventName: string, params?: Record<string, any>): void {
    if (!this.isProduction) {
      this.debug(`Event: ${eventName}`, params);
    }
  }
}

export const logger = new Logger();
export default logger;

